import { acctPage, usersTable } from "../parts";
import { days, debounce, h, pager, show, th } from "../ui";

export async function usersPage() {
  const st = { q: "", sort: "traffic", order: "", online: "", computers: "", offset: 0 };
  const holder = h("div");
  const search = h("input", { type: "search", placeholder: "Search name, email, id, IP or city", "aria-label": "Search users" }) as HTMLInputElement;
  const onlineBox = h("input", { type: "checkbox", id: "f-online" }) as HTMLInputElement;
  const pcsBox = h("input", { type: "checkbox", id: "f-pcs" }) as HTMLInputElement;
  const cols: [string, string, string][] = [
    ["User", "name", ""],
    ["Computers", "computers", "num"],
    ["Phones", "", "num"],
    ["To", "traffic", "num"],
    ["From", "", "num"],
    ["Sessions", "sessions", "num"],
    ["Session time", "", "num"],
    ["PC-days", "", "num"],
    ["Shares", "", "num"],
    ["Location", "", ""],
    ["Last active", "last_seen", "num"],
    ["Joined", "first_seen", "num"],
  ];
  const load = async () => {
    const r = await acctPage({ q: st.q, sort: st.sort, ...(st.order ? { order: st.order } : {}), online: st.online, computers: st.computers, limit: 50, offset: st.offset });
    if (!r) return;
    const head = cols.map(([label, key, cls]) => {
      const e = th(label, cls);
      if (key) {
        e.classList.add("sortable");
        e.setAttribute("aria-sort", st.sort === key ? ((st.order || (key === "name" ? "asc" : "desc")) === "asc" ? "ascending" : "descending") : "none");
        e.addEventListener("click", () => {
          const cur = st.order || (st.sort === "name" ? "asc" : "desc");
          st.order = st.sort === key ? (cur === "asc" ? "desc" : "asc") : "";
          st.sort = key;
          st.offset = 0;
          void load();
        });
      }
      return e;
    });
    const tbl = usersTable(r.accounts);
    tbl.querySelector("thead tr")!.replaceChildren(...head);
    holder.replaceChildren(tbl, pager(r.total, r.limit, r.offset, (o) => ((st.offset = o), void load())));
  };
  search.addEventListener("input", debounce(() => ((st.q = search.value.trim()), (st.offset = 0), void load())));
  onlineBox.addEventListener("change", () => ((st.online = onlineBox.checked ? "1" : ""), (st.offset = 0), void load()));
  pcsBox.addEventListener("change", () => ((st.computers = pcsBox.checked ? "1" : ""), (st.offset = 0), void load()));
  show(
    "Users",
    `Every Luwu account, with usage for the last ${days()} days. Click a column to sort; open a user for devices, usage by day and node, shares, orders and the log.`,
    h(
      "div",
      { class: "listbar" },
      h("div", { class: "tools" }, h("label", { class: "check", for: "f-online" }, onlineBox, " Online now"), h("label", { class: "check", for: "f-pcs" }, pcsBox, " Has computers")),
      h("div", { class: "tools" }, search),
    ),
    holder,
  );
  await load();
}
